const translation = {
  es: {
    nav: {
      home: "Inicio",
      sales: "Ventas",
      purchases: "Compras",
      darkMode: "Modo oscuro",
      lightMode: "Modo claro",
      spanish: "Español",
      english: "Inglés",
      logout: "Cerrar sesión",
    },
  },
  en: {
    nav: {
      home: "Dashboard",
      sales: "Sales",
      purchases: "Purchases",
      darkMode: "Dark mode",
      lightMode: "Light mode",
      spanish: "Spanish",
      english: "English",
      logout: "Logout",
    },
  },
};

export default translation;
